// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    getOficinas as listOficinasAPI,
    getOficina as getOficinaAPI,
    addOficina as addOficinaAPI,
    updateOficina as updateOficinaAPI,
    deleteOficina as deleteOficinaAPI
} from '../../helpers/';

// import { APICore, setAuthorization } from '../../helpers/api/apiCore';
import { oficinasApiResponseError, oficinasApiResponseSuccess } from './actions';
import { OficinasActionTypes } from './constants';

// const api = new APICore();

/**
 * Get contacto
 * @param {*} payload - username and password
 */
function* getOficina({ payload: { id } }) {
    try {
        const response = yield call(getOficinaAPI, id );
        const contacto = response.data.data;
        // NOTE - You can change this according to response format from your api
        // api.setLoggedInUser(user);
        // setAuthorization(user['token']);
        yield put(oficinasApiResponseSuccess(OficinasActionTypes.GET_OFICINA, contacto));
    } catch (error) {
        yield put(oficinasApiResponseError(OficinasActionTypes.GET_OFICINA, error));
        // api.setLoggedInUser(null);
        // setAuthorization(null);
    }
}

/**
 * List contactos
 */
function* listOficinas({payload:params}) {
    try {
        const response = yield call(listOficinasAPI, { ...params });
        const listaOficinas = response.data.data;
        yield put(oficinasApiResponseSuccess(OficinasActionTypes.LIST_OFICINAS, listaOficinas));
    } catch (error) {
        yield put(oficinasApiResponseError(OficinasActionTypes.LIST_OFICINAS, error));
    }
}

function* addOficina({payload:oficina}){
    try{
        const response = yield call(addOficinaAPI,{...oficina})
        const office = response.data.data
        yield put(oficinasApiResponseSuccess(OficinasActionTypes.ADD_OFICINA,office))
    }catch(error){
        yield put(oficinasApiResponseError(OficinasActionTypes.ADD_OFICINA,error))
    }
}

function* updateOficina({payload:oficina}){
    try{
        const response = yield call(updateOficinaAPI,{...oficina})
        const office = response.data.data
        yield put(oficinasApiResponseSuccess(OficinasActionTypes.UPDATE_OFICINA,office))
    }catch(error){
        yield put(oficinasApiResponseError(OficinasActionTypes.UPDATE_OFICINA,error))
    }
}

function* deleteOficina({payload:{id}}){
    try{
        const response = yield call(deleteOficinaAPI,id)
        const office = response.data.id
        yield put(oficinasApiResponseSuccess(OficinasActionTypes.DELETE_OFICINA,office))
    }catch(error){
        yield put(oficinasApiResponseError(OficinasActionTypes.DELETE_OFICINA,error))
    }
}


export function* watchGetOficina(): any {
    yield takeEvery(OficinasActionTypes.GET_OFICINA, getOficina);
}

export function* watchListOficinas(): any {
    yield takeEvery(OficinasActionTypes.LIST_OFICINAS, listOficinas);
}

export function* watchAddOficina():any{
    yield takeEvery(OficinasActionTypes.ADD_OFICINA, addOficina);
}

export function* watchUpdateOficina(): any{
    yield takeEvery(OficinasActionTypes.UPDATE_OFICINA, updateOficina);
}
export function* watchDeleteOficina(): any{
    yield takeEvery(OficinasActionTypes.DELETE_OFICINA, deleteOficina);
}


function* oficinasSaga(): any {
    yield all([
        fork(watchGetOficina),
        fork(watchListOficinas),
        fork(watchAddOficina),
        fork(watchUpdateOficina),
        fork(watchDeleteOficina),
    ]);
}

export default oficinasSaga;
